import { createSlice } from '@reduxjs/toolkit'

const selectedDataSlice = createSlice({
  name: 'selectedData',
  initialState: {
    selectedDestinations: [],
    selectedDates: {},
    selectedDeviceDetails:{},
    planUpdatedData: {},
    failedUpdateCartData: [],
    recurringPlanSelected: false,
    loadConfirmPage: false,
    sessionIdVar:"",
    retainDatesAndDestinations:false,
    devicesPlansAPIFetch: false,
    unauthToAuth:false
  },
  reducers: {
    saveSelectedDestinations: (state, param) => {
      const { payload } = param;
      state.selectedDestinations = payload;
    },
    saveSelectedDates: (state, param) => {
      const { payload } = param;
      state.selectedDates = payload;
    },
    saveSelectedDeviceDetails:(state, param) => {
      const { payload } = param;
      state.selectedDeviceDetails = payload;
    },
  
    updateSelectedPlanData:(state, param) => {
      let { payload } = param;
      state.planUpdatedData = payload;
    },
    clearSelectedPlanData:(state) => {
      state.planUpdatedData = {};
    },
    saveFailedPlanData:(state, param) => {
      let { payload } = param;
      state.failedUpdateCartData = payload;
    },
    setRecurringPlanSelected:(state, param) => {
      let { payload } = param;
      state.recurringPlanSelected = payload
    },
    setConfirmationPage:(state, param) => {
      let { payload } = param;
      state.loadConfirmPage = payload
    },
    setSessionIdVar:(state, param) => {
      let { payload } = param;
      state.sessionIdVar = payload
    },
    
    setRetainDatesAndDestinations:(state, param) => {
      let { payload } = param;
      state.retainDatesAndDestinations = payload
    },
    clearFailedCartData:(state) => {
      state.failedUpdateCartData = [];
    },
    setDevicesPlansAPIFetch: (state, param) => {
      let { payload } = param;
      state.devicesPlansAPIFetch = payload
    }
    ,
    setUnauthToAuth: (state, param) => {
      let { payload } = param;
      state.unauthToAuth = payload
    }
  },
})

const { actions, reducer } = selectedDataSlice;
export const { saveSelectedDestinations, saveSelectedDates, saveSelectedDeviceDetails, updateSelectedPlanData, clearSelectedPlanData, saveFailedPlanData, setRecurringPlanSelected, setConfirmationPage, clearFailedCartData,setRetainDatesAndDestinations, setDevicesPlansAPIFetch,setUnauthToAuth, setSessionIdVar } = actions;
export default reducer;



